export default __webpack_public_path__ + "static/media/shan002.38e76b30.jpeg";